import { createFetch } from '@vueuse/core'
import { defineStore } from 'pinia'

import { noteModuleRefusal } from '@/libs/license'

/**
 * The site's one way of talking to the hotel.
 *
 * No Authorization header, no token, no cookie — and that is not an omission. This is
 * a booking engine: there is nothing to authenticate as, and every address it calls is
 * a public one (pms-api/HTTP_API/Booking.go). A header would be a place for somebody
 * to later put a credential into a page that is served to strangers.
 *
 * Same origin, always. The site's own Caddy proxies /api/pms/v1/* to the API, so a
 * relative base is the only one that works — and the only one the page's content
 * policy allows it to reach.
 */
export const useFetchStore = defineStore('fetch', () => {
    const fetch = createFetch({
        baseUrl: '/api/pms/v1',
        options: {
            // A booking form left open on a phone in a pocket comes back to a request
            // that has been waiting a long time. Failing it is honest; hanging on it
            // is a spinner nobody can get out of.
            timeout: 20000,

            // The hotel has not bought the booking engine. Noticed here, in the one
            // place every call passes through: the /booking tree is gated as one
            // branch, so whichever call comes first — the house, the offers, the
            // booking itself — is refused the same way, and the site has to say so
            // instead of drawing an empty search form that leads nowhere.
            onFetchError(ctx) {
                noteModuleRefusal(ctx.response?.status, ctx.data)

                return ctx
            },
        },
        fetchOptions: {
            headers: { 'Content-Type': 'application/json' },
        },
    })

    return { fetch }
})
